/** Códigos 409 com tratamento dedicado (não são bloqueio genérico de automação). */
const RESERVED_CONFLICT_CODES = new Set([
  "required_tasks_pending",
  "multiple_matches",
]);

/**
 * Indica bloqueio por regra de automação (HTTP 409 sem código reservado).
 */
export function isAutomationRuleBlockError(err) {
  if (Number(err?.status) !== 409) return false;
  const code = err?.code ?? err?.data?.code ?? null;
  if (code && RESERVED_CONFLICT_CODES.has(String(code))) return false;
  return true;
}

export function getAutomationBlockMessage(
  err,
  fallback = "Esta ação foi bloqueada por uma regra de automação."
) {
  const msg = typeof err?.message === "string" ? err.message.trim() : "";
  if (msg) return msg;
  const nested =
    typeof err?.data?.message === "string"
      ? err.data.message.trim()
      : typeof err?.response?.data?.message === "string"
        ? err.response.data.message.trim()
        : "";
  return nested || fallback;
}
